import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";

type Tables = {
  bagSizes: Array<number>,
  lvls: Array<{
    headliner: Array<number>,
    shop: Array<number>,
  }>
};

const lvlXps = [2, 2, 6, 10, 20, 36, 48, 80, 84]

export default function RerollTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Reroll"} />
        <div className="grid grid-cols-[repeat(6,auto)] items-center font-montserrat font-medium mt-6">
          <div className="ml-[60px] pb-2 text-lg font-medium">
            Roll Odds
          </div>
          {tables.bagSizes.map((v, idx) => (
            <div key={idx} className="flex flex-col items-center gap-1 pb-2">
              <div className="flex items-center gap-1">
                <div className="font-montserrat font-medium">
                  {(idx + 1)}
                </div>
                <img
                  src={`https://ap.tft.tools/img/general/gold.png?w=14`}
                  width={14}
                  height={14}
                />
              </div>
              <div className="flex items-center gap-1 text-sm leading-tight">
                <img
                  src={`https://ap.tft.tools/img/general/${idx + 1}cost.jpg?w=${16}`}
                  width={16}
                  height={16}
                />
                <div className="font-montserrat font-medium">
                  {v}
                </div>
              </div>
            </div>
          ))}
          {tables.lvls.slice(1).map((lvl, idx) => (
            <>
              <div className={`flex items-center gap-2 pl-4 py-[14px] ${idx % 2 == 0 ? "bg-bg2" : ""}`}>
                <div className="text-sm text-right w-[38px] leading-none text-white2">
                  {lvlXps[idx]}xp
                </div>
                <div>
                  {`Level ${idx + 2}`}
                </div>
              </div>
              {lvl.shop.map((odds, idx2) => {
                const hlOdds = lvl.headliner[idx2]
                 return (
                  <div key={idx2} className={`flex justify-center gap-2 py-[14px] ${idx % 2 == 0 ? "bg-bg2" : ""}`}>
                    <div className={`w-10 text-right ${odds === 0 ? "text-white2" : ""}`}>
                      {`${(odds * 100).toFixed()}%`}
                    </div>
                    <div className={`${hlOdds === 0 ? "text-white2" : ""} flex w-16 `}>
                      {`(`}
                      <img className={`ml-[1px] mr-[2px] inline-block ${hlOdds === 0 ? "opacity-70" : ""}`} src="https://ap.tft.tools/img/general/headliner_tmp.png?w=14" width="14" height="14" />
                      {`${(hlOdds * 100).toFixed()}%)`}
                    </div>
                  </div>
                ) 
              })}
            </>
          ))}
        </div>
        <div />
      </div>
    </AdLayout>
  )
}
